import {Component, OnInit} from '@angular/core';
import {PagesHttpService} from '../../../services/http-services/pages/pages-http.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
})
export class PrivacyPolicyComponent implements OnInit {
  privacyPolicyPageContent = '';
  constructor(private pagesHttpService: PagesHttpService) {
  }

  ngOnInit(): void {
    this.getPrivacyPolicyPageContent();
  }

  getPrivacyPolicyPageContent(): void {
    this.pagesHttpService.getSinglePage({pageId: 2}).then(res => {
      this.privacyPolicyPageContent = res.data.content.replace(/&nbsp;/g, ' ');
    });
  }
}
